import React, { useState } from "react";
import {
  Box,
  Typography,
  Divider,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Snackbar
} from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { tr } from 'date-fns/locale';
import { MdDelete, MdAdd, MdEdit, MdCheck } from "react-icons/md";
import { BiShow } from "react-icons/bi";
import { useOutletContext } from "react-router-dom";
import "../../../styles/admin.css/machine-modifications-css/manage-cars.css";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://162.35.181.149:5000/api";

export default function Expenses() {
  const { sidebarOpen } = useOutletContext();
  const [periods, setPeriods] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [expandedCategory, setExpandedCategory] = useState(null);

  const totalExpenses = selectedPeriod?.ExpenseCategories?.reduce((sum, cat) => {
    return sum + (cat.ExpensePayments?.reduce((pSum, payment) => pSum + parseFloat(payment.amount || 0), 0) || 0);
  }, 0) || 0;

  const [openPeriodDialog, setOpenPeriodDialog] = useState(false);
  const [openCategoryDialog, setOpenCategoryDialog] = useState(false);
  const [openPaymentDialog, setOpenPaymentDialog] = useState(false);
  const [editPayment, setEditPayment] = useState(null);

  const [periodForm, setPeriodForm] = useState({ startDate: null, endDate: null });
  const [categoryForm, setCategoryForm] = useState({ name: '', budget: '' });
  const [paymentForm, setPaymentForm] = useState({ amount: '' });

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const fetchPeriods = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${BASE_URL}/Expense/periods`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPeriods(response.data.data);
      return response.data.data;
    } catch (error) {
      console.error(error);
      setSnackbar({ open: true, message: 'Xəta baş verdi', severity: 'error' });
      return [];
    }
  };

  React.useEffect(() => {
    fetchPeriods();
  }, []);

  const handleCreatePeriod = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${BASE_URL}/Expense/periods`, periodForm, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSnackbar({ open: true, message: 'Dövr uğurla əlavə edildi', severity: 'success' });
      setOpenPeriodDialog(false);
      setPeriodForm({ startDate: null, endDate: null });
      fetchPeriods();
    } catch (error) {
      console.error(error);
      setSnackbar({ open: true, message: 'Xəta baş verdi', severity: 'error' });
    }
  };

  const handleDeletePeriod = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${BASE_URL}/Expense/periods/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSnackbar({ open: true, message: 'Dövr uğurla silindi', severity: 'success' });
      fetchPeriods();
    } catch (error) {
      console.error(error);
      setSnackbar({ open: true, message: 'Xəta baş verdi', severity: 'error' });
    }
  };

  const handleSelectPeriod = (period) => {
    setSelectedPeriod(period);
    fetchPeriods();
  };

  const handleCreateCategory = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${BASE_URL}/Expense/categories`, {
        ...categoryForm,
        periodId: selectedPeriod.id
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSnackbar({ open: true, message: 'Kateqoriya uğurla əlavə edildi', severity: 'success' });
      setOpenCategoryDialog(false);
      setCategoryForm({ name: '', budget: '' });
      const updatedPeriods = await fetchPeriods();
      const updatedPeriod = updatedPeriods.find(p => p.id === selectedPeriod.id);
      if (updatedPeriod) {
        setSelectedPeriod(updatedPeriod);
      }
    } catch (error) {
      console.error(error);
      setSnackbar({ open: true, message: 'Xəta baş verdi', severity: 'error' });
    }
  };

  const handleDeleteCategory = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${BASE_URL}/Expense/categories/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSnackbar({ open: true, message: 'Kateqoriya uğurla silindi', severity: 'success' });
      const updatedPeriods = await fetchPeriods();
      const updatedPeriod = updatedPeriods.find(p => p.id === selectedPeriod.id);
      if (updatedPeriod) {
        setSelectedPeriod(updatedPeriod);
      }
    } catch (error) {
      console.error(error);
      setSnackbar({ open: true, message: 'Xəta baş verdi', severity: 'error' });
    }
  };

  const handleCreatePayment = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${BASE_URL}/Expense/payments`, {
        paymentDate: new Date(),
        amount: paymentForm.amount,
        categoryId: expandedCategory
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSnackbar({ open: true, message: 'Ödəniş uğurla əlavə edildi', severity: 'success' });
      setOpenPaymentDialog(false);
      setPaymentForm({ amount: '' });
      const updatedPeriods = await fetchPeriods();
      const updatedPeriod = updatedPeriods.find(p => p.id === selectedPeriod.id);
      if (updatedPeriod) {
        setSelectedPeriod(updatedPeriod);
      }
    } catch (error) {
      console.error(error);
      setSnackbar({ open: true, message: 'Xəta baş verdi', severity: 'error' });
    }
  };

  const handleUpdatePayment = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${BASE_URL}/Expense/payments/${editPayment.id}`, {
        paymentDate: new Date(),
        amount: paymentForm.amount
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSnackbar({ open: true, message: 'Ödəniş uğurla yeniləndi', severity: 'success' });
      setOpenPaymentDialog(false);
      setPaymentForm({ amount: '' });
      setEditPayment(null);
      const updatedPeriods = await fetchPeriods();
      const updatedPeriod = updatedPeriods.find(p => p.id === selectedPeriod.id);
      if (updatedPeriod) {
        setSelectedPeriod(updatedPeriod);
      }
    } catch (error) {
      console.error(error);
      setSnackbar({ open: true, message: 'Xəta baş verdi', severity: 'error' });
    }
  };

  const handleDeletePayment = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${BASE_URL}/Expense/payments/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSnackbar({ open: true, message: 'Ödəniş uğurla silindi', severity: 'success' });
      const updatedPeriods = await fetchPeriods();
      const updatedPeriod = updatedPeriods.find(p => p.id === selectedPeriod.id);
      if (updatedPeriod) {
        setSelectedPeriod(updatedPeriod);
      }
    } catch (error) {
      console.error(error);
      setSnackbar({ open: true, message: 'Xəta baş verdi', severity: 'error' });
    }
  };

  const handleEditPayment = (payment) => {
    setEditPayment(payment);
    setPaymentForm({
      paymentDate: new Date(payment.paymentDate),
      amount: payment.amount
    });
    setOpenPaymentDialog(true);
  };

  if (!selectedPeriod) {
    return (
      <Box className={`total-payments-container ${sidebarOpen ? "sidebar-open" : ""}`}>
        <Box className="total-payments-header">
          <Box className="total-payments-title">
            <Typography style={{ color: "#545A61" }}>Xərclər</Typography>
            <Divider className="total-payments-divider" />
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, alignItems: 'center', marginTop: 20, width: '100%' }}>
            <Button
              variant="contained"
              onClick={() => setOpenPeriodDialog(true)}
              sx={{ minWidth: 120, backgroundColor: '#3B7DDD' }}
              startIcon={<MdAdd />}
            >
              Əlavə Et
            </Button>
          </Box>
        </Box>

        <TableContainer component={Paper} className="total-payments-table">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>#No</strong></TableCell>
                <TableCell><strong>Yaradılma Tarixi</strong></TableCell>
                <TableCell><strong>Tarix Aralığı</strong></TableCell>
                <TableCell><strong>Seçimlər</strong></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {periods.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">Məlumat tapılmadı</TableCell>
                </TableRow>
              ) : (
                periods.map((period, index) => (
                  <TableRow key={period.id}>
                    <TableCell>{"#" + String(period.serialNo || index + 1).padStart(4, "0")}</TableCell>
                    <TableCell>{period.createdAt ? new Date(period.createdAt).toLocaleString('az-AZ') : "-"}</TableCell>
                    <TableCell>
                      {new Date(period.startDate).toLocaleDateString('az-AZ')} / {new Date(period.endDate).toLocaleDateString('az-AZ')}
                    </TableCell>
                    <TableCell className="manage-wrapper">
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => handleSelectPeriod(period)}
                        sx={{ backgroundColor: '#4CAF50' }}
                        startIcon={<MdCheck />}
                      >
                        Seç
                      </Button>
                      <Button
                        variant="contained"
                        size="small"
                        className="btnn-delete"
                        onClick={() => handleDeletePeriod(period.id)}
                        startIcon={<MdDelete />}
                      >
                        Sil
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog open={openPeriodDialog} onClose={() => setOpenPeriodDialog(false)} maxWidth="sm" fullWidth>
          <DialogTitle>Yeni Dövr Əlavə Et</DialogTitle>
          <DialogContent>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
                <DatePicker
                  label="Başlanğıc Tarixi"
                  value={periodForm.startDate}
                  onChange={(newValue) => setPeriodForm({ ...periodForm, startDate: newValue })}
                  renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                />
                <DatePicker
                  label="Bitiş Tarixi"
                  value={periodForm.endDate}
                  minDate={periodForm.startDate}
                  onChange={(newValue) => setPeriodForm({ ...periodForm, endDate: newValue })}
                  renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                />
              </Box>
            </LocalizationProvider>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenPeriodDialog(false)}>Ləğv et</Button>
            <Button onClick={handleCreatePeriod} variant="contained" color="primary">
              Əlavə Et
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    );
  }

  return (
    <Box className={`total-payments-container ${sidebarOpen ? "sidebar-open" : ""}`}>
      <Box className="total-payments-header">
        <Box className="total-payments-title">
          <Typography style={{ color: "#545A61" }}>Xərclər</Typography>
          <Divider className="total-payments-divider" />
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 20, gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6">
              Seçilmiş Dövr: {new Date(selectedPeriod.startDate).toLocaleDateString('az-AZ')} / {new Date(selectedPeriod.endDate).toLocaleDateString('az-AZ')}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              variant="outlined"
              onClick={() => setSelectedPeriod(null)}
            >
              Geri Qayıt
            </Button>
            <Button
              variant="contained"
              onClick={() => setOpenCategoryDialog(true)}
              sx={{ minWidth: 120, backgroundColor: '#3B7DDD' }}
              startIcon={<MdAdd />}
            >
              Kateqoriya Əlavə Et
            </Button>
          </Box>
        </Box>

        <Box sx={{ mt: 2, mb: -1 }}>
          <Box sx={{
            backgroundColor: "#f8f9fa",
            padding: "10px 20px",
            borderRadius: "0",
            borderLeft: "5px solid #2e7d32",
            boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%"
          }}>
            <Typography sx={{ color: "#545A61", fontWeight: "600", fontSize: "0.9rem" }}>
              CƏMİ XƏRCLƏR:
            </Typography>
            <Typography variant="h5" sx={{ color: "#2e7d32", fontWeight: "bold" }}>
              {totalExpenses.toFixed(2)} ₼
            </Typography>
          </Box>
        </Box>
      </Box>

      <TableContainer component={Paper} className="total-payments-table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Adı</strong></TableCell>
              <TableCell><strong>Büdcə</strong></TableCell>
              <TableCell><strong>Ödənilən</strong></TableCell>
              <TableCell><strong>Seçimlər</strong></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {selectedPeriod.ExpenseCategories.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center">Kateqoriya tapılmadı</TableCell>
              </TableRow>
            ) : (
              selectedPeriod.ExpenseCategories.map((category, index) => {
                const paid = category.ExpensePayments.reduce((sum, payment) => sum + parseFloat(payment.amount), 0);
                return (
                  <React.Fragment key={category.id}>
                    <TableRow>
                      <TableCell>{category.name}</TableCell>
                      <TableCell>{parseFloat(category.budget).toFixed(2)} ₼</TableCell>
                      <TableCell>{paid.toFixed(2)} ₼</TableCell>
                      <TableCell className="manage-wrapper">
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => setExpandedCategory(expandedCategory === category.id ? null : category.id)}
                          sx={{ backgroundColor: '#4CAF50' }}
                          startIcon={<MdAdd />}
                        >
                          {expandedCategory === category.id ? 'Gizlət' : 'Əlavə Et'}
                        </Button>
                        <Button
                          variant="contained"
                          size="small"
                          className="btnn-delete"
                          onClick={() => handleDeleteCategory(category.id)}
                          startIcon={<MdDelete />}
                        >
                          Sil
                        </Button>
                      </TableCell>
                    </TableRow>
                    {expandedCategory === category.id && (
                      <TableRow>
                        <TableCell colSpan={4} className="total-payments-expanded-cell">
                          <Box className="payment-detailss">
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                              <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#333' }}>
                                {category.name} — Ödəniş Siyahısı
                              </Typography>
                              <Button
                                variant="contained"
                                size="small"
                                onClick={() => setOpenPaymentDialog(true)}
                                sx={{ backgroundColor: '#3B7DDD' }}
                                startIcon={<MdAdd />}
                              >
                                Ödəniş Əlavə Et
                              </Button>
                            </Box>

                            <TableContainer component={Paper} style={{ boxShadow: "none", marginBottom: "20px" }}>
                              <Table size="small" className="payment-table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell><strong>#No</strong></TableCell>
                                    <TableCell><strong>Ödənilmə Tarixi</strong></TableCell>
                                    <TableCell><strong>Məbləğ</strong></TableCell>
                                    <TableCell><strong>Seçimlər</strong></TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {category.ExpensePayments.length === 0 ? (
                                    <TableRow>
                                      <TableCell colSpan={4} align="center">Ödəniş tapılmadı</TableCell>
                                    </TableRow>
                                  ) : (
                                    category.ExpensePayments.map((payment, pIdx) => (
                                      <TableRow key={payment.id}>
                                        <TableCell>{"#" + String(pIdx + 1).padStart(4, "0")}</TableCell>
                                        <TableCell>{payment.paymentDate ? new Date(payment.paymentDate).toLocaleString('az-AZ') : "-"}</TableCell>
                                        <TableCell>{parseFloat(payment.amount).toFixed(2)} ₼</TableCell>
                                        <TableCell className="manage-wrapper">
                                          <Button
                                            variant="contained"
                                            size="small"
                                            onClick={() => handleEditPayment(payment)}
                                            startIcon={<MdEdit />}
                                          >
                                            Düzəlt
                                          </Button>
                                          <Button
                                            variant="contained"
                                            size="small"
                                            className="btnn-delete"
                                            onClick={() => handleDeletePayment(payment.id)}
                                            startIcon={<MdDelete />}
                                          >
                                            Sil
                                          </Button>
                                        </TableCell>
                                      </TableRow>
                                    ))
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>

                            <TableContainer component={Paper} style={{ boxShadow: "none" }}>
                              <Table size="small" className="payment-table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell><strong>Kateqoriya Adı</strong></TableCell>
                                    <TableCell><strong>Büdcə</strong></TableCell>
                                    <TableCell><strong>Ümumi Ödənilən</strong></TableCell>
                                    <TableCell><strong>Qalıq Büdcə</strong></TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  <TableRow>
                                    <TableCell>{category.name}</TableCell>
                                    <TableCell>{parseFloat(category.budget).toFixed(2)} ₼</TableCell>
                                    <TableCell>{paid.toFixed(2)} ₼</TableCell>
                                    <TableCell style={{ color: (parseFloat(category.budget) - paid) < 0 ? '#d32f2f' : '#2e7d32', fontWeight: 'bold' }}>
                                      {(parseFloat(category.budget) - paid).toFixed(2)} ₼
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={openCategoryDialog} onClose={() => setOpenCategoryDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Kateqoriya Əlavə Et</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
            <TextField
              size="small"
              label="Adı"
              value={categoryForm.name}
              onChange={(e) => setCategoryForm({ ...categoryForm, name: e.target.value })}
              fullWidth
            />
            <TextField
              size="small"
              label="Büdcə"
              type="number"
              value={categoryForm.budget}
              onChange={(e) => setCategoryForm({ ...categoryForm, budget: e.target.value })}
              fullWidth
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCategoryDialog(false)}>Ləğv et</Button>
          <Button onClick={handleCreateCategory} variant="contained" color="primary">
            Əlavə Et
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openPaymentDialog} onClose={() => { setOpenPaymentDialog(false); setEditPayment(null); setPaymentForm({ amount: '' }); }} maxWidth="sm" fullWidth>
        <DialogTitle>{editPayment ? 'Ödəniş Düzəlt' : 'Ödəniş Əlavə Et'}</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
            <TextField
              size="small"
              label="Pul"
              type="number"
              value={paymentForm.amount}
              onChange={(e) => setPaymentForm({ ...paymentForm, amount: e.target.value })}
              fullWidth
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenPaymentDialog(false); setEditPayment(null); setPaymentForm({ amount: '' }); }}>Ləğv et</Button>
          <Button onClick={editPayment ? handleUpdatePayment : handleCreatePayment} variant="contained" color="primary">
            {editPayment ? 'Yenilə' : 'Əlavə Et'}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
